export const CONTAINER_PADDING = "10px";
